import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubscriptionsService } from '../../infrastructure/services/subscriptions.service';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';

@Component({
  selector: 'app-configuracion',
  templateUrl: './configuracion.component.html',
  providers: [SubscriptionsService]
})
export class ConfiguracionComponent implements OnInit {
  sistemas: ItemGeneralListado[];

  constructor(private router: Router,
              private subscriptionsService: SubscriptionsService) { }

  ngOnInit(): void {
    // this.sistemasService.getSistemas()
    //   .subscribe(data => this.sistemas = data);
  }

  navegarNuevoSistema() {
    this.router.navigate(['/soc/configuracion/Sistema', 'nuevo']);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/configuracion.component.ts